import { WaitingForEvent, SocketEvent, LoadingEvent } from "@iventis/types/loading.types";

export const removeWaitingForById = (id: string, waitingFor: WaitingForEvent[]) => waitingFor.filter((e) => e.id !== id);

export const removeWaitingForByEventName = (eventName: SocketEvent | LoadingEvent, waitingFor: WaitingForEvent[]) => waitingFor.filter((e) => e.eventName !== eventName);

export const removeWaitingForByIdAndEventName = (id: string, eventName: SocketEvent | LoadingEvent, waitingFor: WaitingForEvent[]) =>
    waitingFor.filter((e) => !(e.id === id && e.eventName === eventName));
